<template>
  <v-container class="contact-section" id="contact">
    <v-layout column align-center class="contact-header">
      <p class="first-line">Have a question?</p>
      <p class="second-line">GET IN TOUCH</p>
    </v-layout>
    <v-layout column align-center>
      <v-form ref="form" class="form">
        <v-layout class="data-fields">
          <v-text-field
            label="Name"
            v-model="formData.name"
            :rules="textConfig.nameRules"
            dark
            color="white"
          ></v-text-field>
          <v-spacer class="spacer"></v-spacer>
          <v-text-field
            label="E-mail"
            v-model="formData.email"
            :rules="textConfig.emailRules"
            dark
            color="white"
          ></v-text-field>
        </v-layout>
        <v-textarea
          v-model="formData.message"
          class="message-area"
          dark
          :rules="textConfig.messageRule"
          :auto-grow="textConfig.autoGrow"
          :clearable="textConfig.clearable"
          :rows="textConfig.rows"
          clear-icon="clear"
          label="Your message..."
          color="white"
        ></v-textarea>
      </v-form>
      <v-btn
        :disabled="!isFormComplete"
        dark
        color="#FF8F00"
        @click="submitForm"
        :loading="loading"
        class="submit-btn"
      >Submit</v-btn>
    </v-layout>
    <Snackbar
      @closeSnackbar="setSnackbarData"
      :isVisible="snackbarData.isVisible"
      :text="snackbarData.text"
      :color="snackbarData.color"
      :timeout="snackbarData.timeout"
      :x="snackbarData.x"
      :y="snackbarData.y"
    />
  </v-container>
</template>
<script>
import db from "../services/firebase";
import Snackbar from "../shared/Snackbar.vue";

export default {
  components: {
    Snackbar
  },
  data() {
    return {
      formData: {
        name: "",
        email: "",
        message: ""
      },
      textConfig: {
        clearable: true,
        autoGrow: false,
        rows: 6,
        nameRules: [
          v => !!v || "Name is required",
          v => (v && v.length <= 25) || "Name must be less than 25 characters"
        ],
        emailRules: [
          v => !!v || "E-mail is required",
          v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ],
        messageRule: [v => !!v || "Message is required"]
      },
      loading: false,
      snackbarData: {
        isVisible: false,
        text: "",
        color: "",
        timeout: 3000,
        x: "right",
        y: "bottom"
      }
    };
  },
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        db.collection("clients")
          .add(this.formData)
          .then(() => {
            this.setSnackbarData(
              "You have successfully sent me a message!",
              "success",
              true
            );
            this.loading = false;
            this.formData = {
              name: "",
              email: "",
              message: ""
            };
            this.$refs.form.reset();
          })
          .catch(err => {
            this.setSnackbarData(
              "Sorry, something went wrong! Try again!",
              "error",
              true
            );
            this.loading = false;
          });
      }
    },
    setSnackbarData(text, color, isVisible) {
      this.snackbarData.text = text;
      this.snackbarData.color = color;
      this.snackbarData.isVisible = isVisible;
    },
    clearSnackBarData() {
      this.snackbarData.text = "";
      this.snackbarData.color = "";
      this.snackbarData.isVisible = false;
    }
  },
  watch: {
    "snackbarData.isVisible": function snackbarTimeout(newVal, oldVal) {
      if (newVal === true) {
        setTimeout(() => {
          this.clearSnackBarData();
        }, this.snackbarData.timeout);
      }
    }
  },
  computed: {
    isFormComplete() {
      return (
        this.formData.name &&
        this.formData.name.length <= 25 &&
        this.formData.email &&
        this.formData.message &&
        /.+@.+\..+/.test(this.formData.email)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-section {
  max-width: 100vw;
  background-color: black;
  padding-top: 30px;
  .contact-header {
    margin: 20px;
    color: white;
    font-weight: normal;
    letter-spacing: 2px;
    .first-line {
      font-size: 2.875rem;
      text-align: center;
    }
    .second-line {
      font-size: 1.5625rem;
      @media screen and (max-width: 325px) {
        font-size: 1.5rem;
      }
    }
  }
  .form {
    width: 450px;
    @media screen and (max-width: 600px) {
      width: 100%;
      padding: 0 30px;
    }
    @media screen and (min-width: 1400px) {
      width: 500px;
    }
    .data-fields {
      flex-wrap: wrap;
      flex-direction: row;
      @media screen and (max-width: 600px) {
        flex-direction: column;
      }
    }
    .spacer {
      width: 20px;
    }
    .message-area ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #f5f5f5;
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f5f5f5;
    }
    ::-webkit-scrollbar-thumb {
      background-color: grey;
    }
  }
  .submit-btn {
    margin: 30px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue